import Stomp from 'stompjs'
import SockJS from 'sockjs-client'

export class Notificationtype {

  static NEW_TRANSACTION_TARGET = 'NEW_TRANSACTION_TARGET';
  static NODE_PING_UPDATE_BY_READPOINT = 'NODE_PING_UPDATED';
  static SAVE_TRANSACTION = "SAVE_TRANSACTION";
  static CLOSE_TRANSACTION_TARGET = "CLOSE_TRANSACTION_TARGET";
}

export default class WebSocketTon {

  static
  const
  NODE_PING_UPDATE_BY_READPOINT = 'NODE_PING_UPDATED';

  socket;
  client;
  isConnected = false;
  static instance;

  constructor() {
    this.socket = new SockJS('/notification/ws/websocket', null);
    this.client = Stomp.over(this.socket);
    this.client.debug = null

    this.socket.onopen = function () {
      console.log('open socket');
    };

    this.socket.onclose = function () {
      console.log('socket closed');
    };

    this.socket.onmessage = function (e) {
      // console.log('message', e.data);
    };
  }

  static getInstance() {
    if (!WebSocketTon.instance) {
      WebSocketTon.instance = new WebSocketTon();
    }
    return WebSocketTon.instance;
  }

  async subscribe(topic, onMessage) {
    await this.connectInWebSocket();

    const eachMessage = (frame) => {
      const object = JSON.parse(frame.body);
      onMessage && onMessage(object);
    }

    const subscription = this.client.subscribe(topic, eachMessage);
    return subscription;
  }

  async connectInWebSocket() {
    return new Promise((resolve, reject) => {
      if (this.client.connected) {
        resolve();
      }
      console.log('try connect in ws');
      this.client.connect({}, (frame) => {
        resolve();
        console.log('Connected: ' + frame);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/WebSocket.js